<template>
  <div>
    <a-col :span="24">
      <div v-if="loading" class="mt-2">
        <center>
          <a-spin/>
        </center>
      </div>
      <div class="pr-2" v-else>
        <roles-form :role="role"></roles-form>
      </div>
    </a-col>
  </div>
</template>

<script>
import RolesForm from "@/components/Cards/Forms/Roles";
export default {
  data() {
    return {
      loading: true,
      role: {
        id: "",
        name: "",
        description: "",
        active: "",
        created_at: ""
      }
    };
  },
  components: { RolesForm },
  methods: {
    fetchRole() {
      this.$store
        .dispatch("getRole", this.$route.params.id)
        .then(s => {
          this.loading = false;
          this.role = s.data;
        })
        .catch(err => {
          this.$message.error("Record for your request was not found!");
        });
    }
  },
  mounted() {
    this.fetchRole();
  }
};
</script>
